import { Component } from '@angular/core';

@Component({
  selector: 'xos-forgot-password-confirmation',
  templateUrl: './forgot-password-confirmation.component.html',
  styleUrls: ['./forgot-password-confirmation.component.scss'],
})
export class ForgotPasswordConfirmationComponent {}
